import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { rolesActions } from '../actions/roles.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class RolesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getRoles$ = createEffect(() => {
        return this.actions.pipe(
            ofType(rolesActions.getRoles),
            switchMap(({ value }) => {
                return this.httpService.getRoles(value).pipe(
                    map((payload) => rolesActions.getRolesSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(rolesActions.getRolesError({ code: response.status }))),
                );
            }),
        );
    });

    getRolesLookup$ = createEffect(() => {
        return this.actions.pipe(
            ofType(rolesActions.getRolesLookup),
            switchMap(() => {
                return this.httpService.getRolesLookup().pipe(
                    map((payload) => rolesActions.getRolesLookupSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(rolesActions.getRolesLookupError({ code: response.status }))),
                );
            }),
        );
    });
}
